import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import App from "./App";
import './style.css';
ReactDOM.render(
  <div>
  <h1 id="head">Calorie Read Only</h1>
  <App/>
  </div>,
  document.getElementById("root")
);